// src/index.js - Alternative version with auth check
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { registerServiceWorker } from './services/pushNotificationService';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <App />
);

// Function to check if user is logged in
const isUserLoggedIn = () => {
  return !!localStorage.getItem('token');
};

// Register service worker only for logged-in users
const initServiceWorker = () => {
  if (!('serviceWorker' in navigator)) {
    // console.log('📱 Service Worker not supported');
    return;
  }
  
  // Check if user is authenticated
  if (!isUserLoggedIn()) {
    // console.log('🔒 User not logged in, skipping SW registration');
    return;
  }
  
  // Register with a small delay
  setTimeout(() => {
    registerServiceWorker()
      .then(registration => {
        if (registration) {
          // console.log('🎯 Service Worker ready for push notifications');
        }
      })
      .catch(error => {
        // Silent fail - push notifications are optional
        // console.debug('SW registration skipped:', error.message);
      });
  }, 1500);
};

// Listen for auth changes to register SW after login
window.addEventListener('user-logged-in', () => {
  // console.log('🔑 User logged in, registering service worker');
  initServiceWorker();
});

// Try initial registration
initServiceWorker();

// Monitor service worker updates
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    // console.log('🔄 New service worker activated');
    
    // Show a subtle update notification
    window.dispatchEvent(new CustomEvent('showToast', {
      detail: {
        title: 'App Updated',
        message: 'New version available. Refresh for latest features.',
        type: 'info',
        action: {
          label: 'Refresh',
          onClick: () => window.location.reload()
        }
      }
    }));
  });
}

reportWebVitals();